import Bowser from "bowser";

export function getBrowserVersion() {
    return Bowser.parse(window.navigator.userAgent);
}

export interface BrowserCompatibility {
    desktop: {
        [browser: string]: string;
    };
}

export const checkTreeMin: BrowserCompatibility = {
    desktop: {
        "Chrome": ">=61",
        "Microsoft Edge": ">=79",
//        "Internet Explorer": "",
        "Opera": ">=51",
        "Safari": ">=11",
        "Firefox": ">=68"
    }
};

export const checkTreeCopyPaste: BrowserCompatibility = {
    desktop: {
        "Chrome": ">=66",
        "Microsoft Edge": ">=79",
        "Opera": ">=56",
    }
};

export const checkTreeVideo: BrowserCompatibility = {
    desktop: {
        "Chrome": ">=61",
        "Microsoft Edge": ">=79",
    }
};

export const compatibilityTexts: {[key: string]: {name: string; version: string; url: string;}} = {
    Chrome: {name: "Chrome", version: "66", url: "https://www.google.com/chrome/"},
    "Microsoft Edge": {name: "Microsoft Edge", version: "79", url: "https://www.microsoft.com/edge"},
    Opera: {name: "Opera", version: "56", url: "https://www.opera.com/download"},
};

export function minimumRequirements(): boolean {
    return !!Bowser.getParser(window.navigator.userAgent).satisfies(checkTreeMin);
}

export function copyPasteRequirements(): boolean {
    return !!Bowser.getParser(window.navigator.userAgent).satisfies(checkTreeCopyPaste);
}

export function videoRequirements(): boolean {
    return !!Bowser.getParser(window.navigator.userAgent).satisfies(checkTreeVideo);
}
